//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const DVS_ADMIN_API_BASE_URL = new InjectionToken<string>('DVS_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminDocumentsClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(DVS_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(stateType: DocumentStateType | null, isDeleted: boolean | null, userId: string | null, documentKey: string | null, page?: number | undefined, pageSize?: number | undefined): Observable<SwaggerResponse<AdminDocumentDto[]>> {
        let url_ = this.baseUrl + "/admin/documents?";
        if (stateType === undefined)
            throw new globalThis.Error("The parameter 'stateType' must be defined.");
        else if(stateType !== null)
            url_ += "stateType=" + encodeURIComponent("" + stateType) + "&";
        if (isDeleted === undefined)
            throw new globalThis.Error("The parameter 'isDeleted' must be defined.");
        else if(isDeleted !== null)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (userId === undefined)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        else if(userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (documentKey === undefined)
            throw new globalThis.Error("The parameter 'documentKey' must be defined.");
        else if(documentKey !== null)
            url_ += "documentKey=" + encodeURIComponent("" + documentKey) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AdminDocumentDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AdminDocumentDto[]>>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SwaggerResponse<AdminDocumentDto[]>> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.Search');
            }));
        }
        return _observableOf<SwaggerResponse<AdminDocumentDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getHistory(documentId: number): Observable<AdminDocumentHistoryEntryDto[]> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/history";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDocumentHistoryEntryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDocumentHistoryEntryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<AdminDocumentHistoryEntryDto[]> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminDocumentHistoryEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.GetHistory');
            }));
        }
        return _observableOf(null as any);
    }

    applyVerificationAction(documentId: number, request: AdminDocumentVerificationRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/documents/{documentId}/verification";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyVerificationAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyVerificationAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyVerificationAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminDocumentsProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminDocumentsClient.ApplyVerificationAction');
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminDocumentDto implements IAdminDocumentDto {
    id!: number;
    documentKey!: string | undefined;
    documentName!: string | undefined;
    userId!: string;
    customerHumanReadableId!: number | undefined;
    customerName!: string | undefined;
    customerRoleType!: AdminCustomerRole | undefined;
    stateType!: DocumentStateType;
    createdAt!: Date;
    modifiedAt!: Date | undefined;
    deletedAt!: Date | undefined;
    decisionDate!: Date | undefined;
    rusMvdPassportCheck!: boolean | undefined;

    constructor(data?: IAdminDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentKey = _data["documentKey"];
            this.documentName = _data["documentName"];
            this.userId = _data["userId"];
            this.customerHumanReadableId = _data["customerHumanReadableId"];
            this.customerName = _data["customerName"];
            this.customerRoleType = _data["customerRoleType"];
            this.stateType = _data["stateType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : undefined as any;
            this.rusMvdPassportCheck = _data["rusMvdPassportCheck"];
        }
    }

    static fromJS(data: any): AdminDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentKey"] = this.documentKey;
        data["documentName"] = this.documentName;
        data["userId"] = this.userId;
        data["customerHumanReadableId"] = this.customerHumanReadableId;
        data["customerName"] = this.customerName;
        data["customerRoleType"] = this.customerRoleType;
        data["stateType"] = this.stateType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : undefined as any;
        data["rusMvdPassportCheck"] = this.rusMvdPassportCheck;
        return data;
    }
}

export interface IAdminDocumentDto {
    id: number;
    documentKey: string | undefined;
    documentName: string | undefined;
    userId: string;
    customerHumanReadableId: number | undefined;
    customerName: string | undefined;
    customerRoleType: AdminCustomerRole | undefined;
    stateType: DocumentStateType;
    createdAt: Date;
    modifiedAt: Date | undefined;
    deletedAt: Date | undefined;
    decisionDate: Date | undefined;
    rusMvdPassportCheck: boolean | undefined;
}

export enum AdminCustomerRole {
    Undefined = 0,
    Worker = 1,
    Employer = 2,
}

export enum DocumentStateType {
    Undefined = 0,
    Created = 1,
    InProcess = 2,
    ImpossibleToCheck = 3,
    AddOnsRequired = 4,
    SupervisorRequired = 5,
    Rejected = 6,
    Verified = 7,
}

export class AdminDocumentHistoryEntryDto implements IAdminDocumentHistoryEntryDto {
    actionType!: DocumentActionType;
    oldStateType!: DocumentStateType;
    newStateType!: DocumentStateType;
    inspectorId!: string | undefined;
    inspectorName!: string | undefined;
    comment!: string | undefined;
    createdAt!: Date;

    constructor(data?: IAdminDocumentHistoryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.oldStateType = _data["oldStateType"];
            this.newStateType = _data["newStateType"];
            this.inspectorId = _data["inspectorId"];
            this.inspectorName = _data["inspectorName"];
            this.comment = _data["comment"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminDocumentHistoryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentHistoryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["oldStateType"] = this.oldStateType;
        data["newStateType"] = this.newStateType;
        data["inspectorId"] = this.inspectorId;
        data["inspectorName"] = this.inspectorName;
        data["comment"] = this.comment;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminDocumentHistoryEntryDto {
    actionType: DocumentActionType;
    oldStateType: DocumentStateType;
    newStateType: DocumentStateType;
    inspectorId: string | undefined;
    inspectorName: string | undefined;
    comment: string | undefined;
    createdAt: Date;
}

export enum DocumentActionType {
    Create = 1,
    StartProcessing = 2,
    MarkAsImpossibleToCheck = 3,
    RequireAddOns = 4,
    RequireSupervisorCheck = 5,
    Approve = 6,
    Reject = 7,
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class XProblemDetailsOfAdminDocumentsProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminDocumentsProblemCode {
    problemCode!: AdminDocumentsProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminDocumentsProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminDocumentsProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminDocumentsProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminDocumentsProblemCode extends IProblemDetails {
    problemCode: AdminDocumentsProblemCode;

    [key: string]: any;
}

export enum AdminDocumentsProblemCode {
    Unhandled = "Unhandled",
    NotFound = "NotFound",
    DocumentDeleted = "DocumentDeleted",
}

export class AdminDocumentVerificationRequestDto implements IAdminDocumentVerificationRequestDto {
    actionType!: DocumentActionType;
    comment!: string | undefined;
    rejectionReason!: RejectionReason | undefined;

    constructor(data?: IAdminDocumentVerificationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.comment = _data["comment"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): AdminDocumentVerificationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDocumentVerificationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["comment"] = this.comment;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IAdminDocumentVerificationRequestDto {
    actionType: DocumentActionType;
    comment: string | undefined;
    rejectionReason: RejectionReason | undefined;
}

export enum RejectionReason {
    Undefined = 0,
    PoorDocumentQuality = 1,
    ImpossibleToCheck = 2,
    SuspicionOfForgery = 3,
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}